import { AutogenModelTariff, AutogenRowTariff } from "./autogen/AutogenModelTariff";

export class ModelTariff extends AutogenModelTariff<RowTariff> {
    constructor() {
        super(RowTariff);
    }
}

export class RowTariff extends AutogenRowTariff {
}